<!-- NOTE: -->
<!-- This component is not up to date (not used) -->
<!-- The select input that is used is at @/components/formulate/SelectInputResourceful -->
<!-- The file is still kept in for the sake of archiving and reference -->

<template>
  <multiselect
    v-bind="{ ...$attrs }"
    ref="multiselect"
    tabIndex="0"
    :value="inputValueGetter"
    :custom-label="customLabel"
    :options="options"
    :loading="loading"
    :placeholder="placeholder"
    @input="inputValueSetter"
    @close="handleClose"
    @open="handleOpen"
    @search-change="handleSearchChange"
  >
    <!-- Slot: after the list of options, when this element is in view, trigger pagination event -->
    <template #afterList>
      <div v-if="loading" class="px-2 py-2 d-flex gap-3 flex-column">
        <b-skeleton v-for="(i, idx) in ['100', '100']" :width="i" :key="idx"></b-skeleton>
      </div>
      <div v-observe-visibility="handleElementObserved" style="height: 10px" />
    </template>

    <template #selection="{ isOpen }">
      <i class="mc-fa icon-fill_search me-1" v-if="isOpen"></i>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  props: {
    value: {},
    options: {},
    // Callback for transforming input
    // e.g. set the input value to id instead of whole object
    // TODO: documentation
    transformInputFn: {},
    // Callback for setting option label
    // e.g. set the label to option.name from option = {id: 1, name: 'Lorem'}
    optionLabelFn: {},
    loading: {},
  },
  emits: ['open', 'close', 'search-change', 'pagination'],
  data() {
    return {
      placeholder: this.$attrs.placeholder,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.repositionDropDown)
  },
  destroyed() {
    window.removeEventListener('scroll', this.repositionDropDown)
  },
  computed: {
    // Since we only track the ID, we still need to pass the whole object
    // to vue-multiselect so every selection is detected
    inputValueGetter() {
      const trackBy = this.$attrs['track-by']
      const groupValues = this.$attrs['group-values']
      const selected = this.value
      const isMultiple = Array.isArray(selected)
      const hasGroups =
        typeof this.$attrs['group-label'] !== 'undefined' &&
        typeof this.$attrs['group-values'] !== 'undefined'

      let value = isMultiple ? [] : ''

      const options = hasGroups
        ? this.options.flatMap((option) => option[groupValues])
        : this.options

      // If input has initial value, and options are not loaded
      // return the initial data from attributes
      // if (selected && options.length === 0) return this.$attrs['initialObject']

      for (let item of options) {
        // If multiple
        if (isMultiple && selected.includes(item[trackBy])) {
          value.push(item)
        }
        // If single
        else if (item[trackBy] === selected) {
          value = item
          break
        }
      }

      return value
    },
    optionsContainerRef() {
      return this.$refs?.multiselect?.$refs?.list
    },
  },
  methods: {
    repositionDropDown() {
      // const { top, height } = this.$el.getBoundingClientRect()
      // this.optionsContainerRef.style.width = `${this.$el.clientWidth}px`
      // this.optionsContainerRef.style.position = 'fixed'
      // this.optionsContainerRef.style.bottom = 'auto'
      // this.optionsContainerRef.style.top = `${top + height}px`
    },
    // Since we usually only track the ID, we need to parse the option
    // selected by vue-multiselect and give the transformInputFn to the
    // parent component
    inputValueSetter(input) {
      if (this.transformInputFn) {
        this.$emit('input', this.transformInputFn({ input }))
        return
      }

      return this.$emit('input', input)
    },
    customLabel(item) {
      if (this.optionLabelFn) {
        return this.optionLabelFn({
          item,
          options: this.options,
        })
      }

      return item
    },
    handleElementObserved(isVisible) {
      if (!isVisible) return

      this.$emit('pagination')

      // Scroll to bottom when pagination is triggered
      this.$nextTick().then(() => {
        if (typeof this.optionsContainerRef !== 'function') return
        this.optionsContainerRef.scrollTo({
          top: this.optionsContainerRef.scrollHeight,
          behavior: 'smooth',
        })
      })
    },
    handleOpen() {
      this.$emit('open')
      this.placeholder = 'Search'
      this.repositionDropDown()
    },
    handleClose() {
      this.$emit('close')
      this.placeholder = this.$attrs.placeholder
    },
    handleSearchChange(search) {
      this.$emit('search-change', search)

      // Scroll to top when search query is changed
      this.$nextTick().then(() => {
        if (typeof this.optionsContainerRef !== 'function') return
        this.optionsContainerRef.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      })
    },
  },
}
</script>
